const spacing = {
  slim: "4px",
  cozy: "8px",
  moderate: "16px",
  normal: "24px",
  comfy: "32px",
  shakira: "32px", // NOTE: this constant is deprecated. It will be removed in the future.
  spacious: "48px",
  giant: "64px",
  colossal: "88px",
  gutters: {
    tiny: 8,
    small: 16,
    mediumAndUp: 24,
    largeAndUp: 32
  }
};

export default spacing;
